import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@fiverr-private/fit';
import * as Translations from '../../providers/i18n';

import './style.scss';

const CommentsSummaryToSubmitModalTrigger = ({ open, i18n }) => (
    <div className="comments-summary-modal-trigger">
        <Button onClick={open} className="comments-summary-modal-trigger-btn">
            {i18n.t('attachments_preview.comments_summary_modal.trigger_button')}
        </Button>
    </div>
);

CommentsSummaryToSubmitModalTrigger.propTypes = {
    open: PropTypes.func,
    i18n: PropTypes.shape({
        t: PropTypes.func
    })
};

CommentsSummaryToSubmitModalTrigger.defaultProps = {
    open: Function.prototype
};

export default Translations.connect(CommentsSummaryToSubmitModalTrigger);
